import { inRange } from 'lodash';
import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { NotificationManager } from './notification-manager';
import { Translate } from './translate';

export interface IResponse {
  status: number;
  data: {
    message?: string;
    type?: string;
  };
}

export type IStandardErrorParser = (response: IResponse) => ng.IPromise<any>;

/**
 * Response error parser - it's a function to be called in catch() to keep the
 * standard failed request processing. It's making sure that for not expected
 * failures (403, 5xx) we always give user readable message in the interface
 */
export const StandardErrorParserProvider = {
  provide: 'standardErrorParser',
  deps: ['$q', 'translate', 'currentSession', 'notificationManager'],
  useFactory: (
    $q: ng.IQService,
    translate: Translate,
    currentSession: CurrentSession,
    notificationManager: NotificationManager,
  ): IStandardErrorParser => {
    const $translate = translate;

    return (response: IResponse) => {
      let notification;

      if (inRange(response.status, 400, 405)) {
        notification = response.data.message;
      } else if (500 <= response.status && response.status < 600) {
        notification =
          $translate.instant('shared.connection_error.status_5xx') +
          ' Status: ' +
          response.status;
      }

      if (notification && currentSession.isLogged) {
        notificationManager.sendError(notification, 'http-error');
      }

      let message = '';

      if (
        angular.isString(response.data) ||
        // TODO cover those cases by tests
        response.data === null ||
        angular.isUndefined(response.data)
      ) {
        if (500 <= response.status && response.status < 600) {
          message = $translate.instant('shared.connection_error.status_5xx');
        } else {
          message = $translate.instant('shared.connection_error.offline');
        }

        response.data = {
          message,
        };
      } else {
        // TODO GATE-248 move to gate controller
        if (
          response.status === 400 &&
          response.data.type === 'NoActiveTenantsFound'
        ) {
          response.data.message =
            response.data.message +
            ' <a href="/#/support">' +
            $translate.instant('shared.contact_support') +
            '</a>';
        } else if (response.status === 401) {
          response.data.message =
            response.data.message +
            ' <a href="/#/request-password-reset">' +
            $translate.instant('shared.forgot_password') +
            '</a>';
        }
      }

      return $q.reject(response);
    };
  },
};
